module.exports = __webpack_public_path__ + "img/supportimg.03fe2206.png";